import { STRUCTURE_VALUES, VEGETATION_VALUES } from "constants/urbanNodes";

// Count structure vs vegetation nodes in an urban FeatureCollection. Returns { structure, vegetation }.
export function countNodeTypes(featureCollection) {
  if (!featureCollection?.features?.length) {
    return { structure: 0, vegetation: 0 };
  }
  let structure = 0;
  let vegetation = 0;
  for (const f of featureCollection.features) {
    const t = f.properties?.node_type;
    if (STRUCTURE_VALUES.includes(t)) structure += 1;
    else if (VEGETATION_VALUES.includes(t)) vegetation += 1;
  }
  return { structure, vegetation };
}
